module.exports = __webpack_public_path__ + "img/1.154e0cd2.png";